var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcgamer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3 2.5 42.2 26",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.27 28.1c6.54 0 9.29-3.59 10.46-8.51L38.6 18.2c-.75 3.02-1.78 4.63-4.3 4.63-3.21 0-4.8-2.9-4.8-7.36 0-4.53 1.52-7.2 4.73-7.2 2.5 0 3.4 1.85 4.04 4.18l6.12-1.84c-1-4.34-3.6-7.75-10.13-7.75-6.08 0-11.23 3.7-11.23 12.61S27.96 28.1 34.27 28.1M9.7 14.89V8.65h2.79c3 0 3.82 1.28 3.82 3.12s-.81 3.12-3.82 3.12h-2.8zM3.3 27.64h6.4v-7.76h2.56c4.7 0 10.36-1.08 10.36-8.28s-5.24-8.27-10.36-8.27H3.3v24.3zM154.64 11.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcgamer);
export default __webpack_public_path__ + "static/media/pcgamer.221b16a09624758f494d33e1dd85c0e3.svg";
export { ForwardRef as ReactComponent };